export default "__VITE_ASSET__Wup6yvpM__"